import axios from 'axios';

import {
  configureHttpHeaders,
  onSuccess,
  onError,
} from './apiHelpers';
import { getReferenceDataBaseUrl } from './referenceDataBaseUrl.js';


const REFERENCE_DATA_DATA_API = getReferenceDataBaseUrl();

export function postFilterValues(resultString) {
  const Url = 'api/v1/referencedata/disputecase/unmatched/transactions?';
  configureHttpHeaders(axios);
  return get(`${REFERENCE_DATA_DATA_API}${Url}`, resultString);
}

export function getMerchantData(merchantNumber) {
  const Url = `api/v1/referencedata/disputecase/merchant?merchantNumber=${merchantNumber}`;
  configureHttpHeaders(axios);
  return getBase(`${REFERENCE_DATA_DATA_API}${Url}`);
}
export function getCurrencyConversionRate(conversionDate, fromCurrency, toCurrency) {
  const Url = `api/v1/referencedata/currency/rate?conversionDate=${conversionDate}&fromCurrency=${fromCurrency}&toCurrency=${toCurrency}`;
  configureHttpHeaders(axios);
  return getBase(`${REFERENCE_DATA_DATA_API}${Url}`);
}
export function getRelatedTransactionData(args) {
  const sortObj = args.sortArray.map(obj => {
    return {
      fieldId: obj.key,
      orderByProperty: (obj.order) ? 'ASC' : 'DESC',
    }
  })
  const Url = `api/v1/referencedata/related/transactions?acquirerCode=${args.acquirerCode}&size=${args.size}&pageNumber=${args.pageNumber}&orderByProperties=${sortObj[0].fieldId}&direction=${sortObj[0].orderByProperty}&globalToken=${args.globalToken}&merchantNumber=${args.merchantNumber}`;
  configureHttpHeaders(axios);
  return getBase(`${REFERENCE_DATA_DATA_API}${Url}`);
}
  
function get(baseURL, url) {
  return axios.get(`${baseURL}${url}`)
      .then(onSuccess)
      .catch(onError);
}
function getBase(baseURL) {
  return axios.get(`${baseURL}`)
    .then(onSuccess)
    .catch(onError);
}
export default {
  postFilterValues,
  getMerchantData,
};
